import type { SessionNoteEntity } from '@web-app/db';

export const SESSION_NOTE_SERVER_MANAGED_FIELDS = [
  'isApproved',
  'approvedAt',
  'healthieChartingNoteId',
] as const satisfies readonly (keyof SessionNoteEntity)[];

// Add new provider-editable SessionNoteEntity fields here so draft saves can persist them.
const SESSION_NOTE_SAVE_FIELDS = [
  'dailyRoomName',
  'appointmentDate',
  'healthieClientId',
  'healthieProviderId',
  'healthieAppointmentId',
  'providerNotes',
  'providerNotesJson',
  'sessionDetails',
  'sessionDetailsJson',
  'apptOccurredOnThePhone',
  'sessionEndedAt',
  'loggedSessionDuration',
  'selectedTemplateName',
] as const satisfies readonly (keyof SessionNoteEntity)[];

export const stripSessionNoteServerManagedFields = <
  T extends Partial<SessionNoteEntity>,
>(
  sessionNote: T,
): Partial<T> =>
  Object.fromEntries(
    Object.entries(sessionNote).filter(
      ([key]) =>
        !(SESSION_NOTE_SERVER_MANAGED_FIELDS as readonly string[]).includes(
          key,
        ),
    ),
  ) as Partial<T>;

export const pickSessionNoteSaveFields = (
  sessionNote: Partial<SessionNoteEntity>,
): Partial<SessionNoteEntity> =>
  Object.fromEntries(
    SESSION_NOTE_SAVE_FIELDS.flatMap((key) =>
      key in sessionNote ? [[key, sessionNote[key]]] : [],
    ),
  );
